import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OperatorFunction, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { catchErrorLogRet, mapDelete, mapList } from '../common/rest.operators';

import { PersonOfInterestModel } from './people-of-interest.user.model';

@Injectable()
export class PeopleOfInterestUserService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    create<T>(
        project: (value: T, index: number) => number,
    ): OperatorFunction<T, boolean> {
        return pipe(
            switchMap((value, index) => {
                const personOfInterestId = project(value, index);
                const params = new HttpParams().set(
                    'personOfInterestId',
                    personOfInterestId.toString(),
                );
                return this._http.post(
                    `${this._appConfig.API_ENDPOINTS.USER_PROFILE}/peopleofinterest`,
                    null,
                    { params },
                );
            }),
            mapDelete(), // TODO revise
            catchErrorLogRet(false),
        );
    }

    list<T>(
        project: (value: T, index: number) => number,
    ): OperatorFunction<T, PersonOfInterestModel[]> {
        return pipe(
            switchMap((value, index) => {
                const scopeId = project(value, index);
                const params = new HttpParams().set(
                    'scopeId',
                    scopeId.toString(),
                );
                return this._http.get(
                    `${this._appConfig.API_ENDPOINTS.USER_PROFILE}/peopleofinterest`,
                    { params },
                );
            }),
            mapList<PersonOfInterestModel[]>(),
            catchErrorLogRet([]),
        );
    }

    delete<T>(
        project: (value: T, index: number) => number,
    ): OperatorFunction<T, boolean> {
        return pipe(
            switchMap((value, index) => {
                const personOfInterestId = project(value, index);
                const params = new HttpParams().set(
                    'personOfInterestId',
                    personOfInterestId.toString(),
                );
                return this._http.delete(
                    `${this._appConfig.API_ENDPOINTS.USER_PROFILE}/peopleofinterest`,
                    { params },
                );
            }),
            mapDelete(),
            catchErrorLogRet(false),
        );
    }
}
